import { sessionStorageKeySet } from "@/src/constant/sessionstorage";
import type { ChatChannel } from "@/src/store/slice/chat";

interface SavedChatState {
  currentChannelUrl: string;
  currentChannel: ChatChannel;
}

/**
 * Save current chat channel state to session storage
 * This is used to restore the chat view when user reopens the chat panel
 */
export const saveChatStateToSession = (
  currentChannelUrl: string | null,
  currentChannel: ChatChannel | null
): void => {
  try {
    if (currentChannelUrl && currentChannel) {
      const chatState: SavedChatState = {
        currentChannelUrl,
        currentChannel,
      };
      
      window.sessionStorage.setItem(
        sessionStorageKeySet.CHAT_STATE,
        JSON.stringify(chatState)
      );
    }
  } catch (error) {
    console.warn("Failed to save chat state to session storage:", error);
  }
};

/**
 * Load saved chat channel state from session storage
 * Returns null if no saved state exists or if there's an error
 */
export const loadChatStateFromSession = (): SavedChatState | null => {
  try {
    const savedState = window.sessionStorage.getItem(sessionStorageKeySet.CHAT_STATE);
    if (savedState) {
      return JSON.parse(savedState) as SavedChatState;
    }
  } catch (error) {
    console.warn("Failed to load chat state from session storage:", error);
  }
  return null;
};

/**
 * Clear saved chat state from session storage
 * This should be called on browser refresh or when we want to reset to channel list
 */
export const clearChatStateFromSession = (): void => {
  try {
    window.sessionStorage.removeItem(sessionStorageKeySet.CHAT_STATE);
  } catch (error) {
    console.warn("Failed to clear chat state from session storage:", error);
  }
};